"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEditorLink = exports.localText = void 0;
var Editor_logic_1 = require("../Editor.logic");
var Editor_static_1 = require("../Editor.static");
var EditorLink_style_1 = __importDefault(require("./EditorLink.style"));
exports.localText = {
    openLinkEditMode: function (url) { return "".concat(url, " (").concat(Editor_static_1.modKey, " + Click to follow link)"); },
};
function useEditorLink(_a) {
    var readOnly = _a.readOnly, url = _a.url;
    var isModBeingHeld = (0, Editor_logic_1.useJackedEditor)().isModBeingHeld;
    var _b = (function () {
        if (readOnly) {
            return {
                tooltip: undefined,
                onClick: undefined,
            };
        }
        return {
            tooltip: exports.localText.openLinkEditMode(url),
            onClick: isModBeingHeld ? function () { return window.open(url, '_blank'); } : undefined,
        };
    })(), tooltip = _b.tooltip, onClick = _b.onClick;
    return {
        isModBeingHeld: isModBeingHeld,
        tooltip: tooltip,
        onClick: onClick,
        classes: (0, EditorLink_style_1.default)(),
    };
}
exports.useEditorLink = useEditorLink;
